import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const flipperReviewsApi = createApi({
  reducerPath: "flipperReviewsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["FlipperReview"],
  endpoints: (build) => ({
    getAllFlipperReviews: build.query({
      query: ({ contractorId, limit = 1000 } = {}) => ({
        url: "/flipper/reviews",
        method: "GET",
        params: { contractorId, limit },
      }),
      providesTags: ["FlipperReview"],
    }),
    createFlipperReview: build.mutation({
      query: (data) => ({ url: "/flipper/reviews", method: "POST", body: data }),
      invalidatesTags: ["FlipperReview"],
    }),
    updateFlipperReview: build.mutation({
      query: ({ id, ...data }) => ({ url: `/flipper/reviews/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["FlipperReview"],
    }),
    deleteFlipperReview: build.mutation({
      query: (id) => ({ url: `/flipper/reviews/${id}`, method: "DELETE" }),
      invalidatesTags: ["FlipperReview"],
    }),
  }),
});

export const {
  useGetAllFlipperReviewsQuery,
  useCreateFlipperReviewMutation,
  useUpdateFlipperReviewMutation,
  useDeleteFlipperReviewMutation,
} = flipperReviewsApi;
